// extracted by mini-css-extract-plugin
var _1 = "_zpBDU";
var _2 = "_E4eLY";
var _3 = "_z0Ny2";
var _4 = "_UYNbO";
var _5 = "_a9XFw";
var _6 = "_TPlbf";
var _7 = "_Bf3SR";
var _8 = "_zaOGI";
var _9 = "_OHM23";
export { _1 as "errorBlock", _2 as "notifications", _3 as "notificationsContainer", _4 as "notificationsContainerError", _5 as "notificationsContent", _6 as "notifyMessage", _7 as "notifyTitle", _8 as "slide", _9 as "successBlock" }
